<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
        offset-md="2"
        offset-sm="1"
        sm="10"
      >
        <v-container
          fluid
          pa-0
        >
          <v-row>
            <v-col cols="12" />
          </v-row>

          <v-row>
            <v-col cols="12">
              <h1 class="brand-text-heading">
                {{ toLocaleUpperCase($t('Account.Title')) }}
              </h1>

              <v-divider
                class="mt-3"
                style="border-color: var(--v-brand-green-dark-base)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-tabs
                background-color="transparent"
                class="rounded"
                color="brand-primary"
                hide-slider
                light
              >
                <template v-for="(item, i) in items">
                  <v-tab
                    v-if="item.active"
                    :key="i"
                    :to="{name: item.to}"
                    active-class="brand-primary brand-green-dark--text"
                    class="v-btn--outlined brand-green--text px-4 mr-2 brand-text-title"
                  >
                    {{ item.text }}
                  </v-tab>
                </template>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row v-if="user">
            <v-col cols="12">
              <router-view
                :key="updateKey"
                :item="customerInfo"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountMixin from '@/theme/default/views/account/Account.js'

export default {
  name  : 'Account',
  mixins: [AccountMixin]
}
</script>

<style scoped src="@/theme/default/views/account/Account.css"></style>
<style scoped>
:deep(.v-slide-group__next), :deep(.v-slide-group__prev) {
  flex: 0 1 32px !important;
  min-width: 32px !important;
}

:deep(.v-slide-group__next--disabled), :deep(.v-slide-group__prev--disabled) {
  flex: 0 1 0 !important;
  min-width: 0 !important;
}
</style>
